import { render, staticRenderFns } from "./LotBuyNowPrice.vue?vue&type=template&id=20e2cdb8&scoped=true"
import script from "./LotBuyNowPrice.vue?vue&type=script&lang=js"
export * from "./LotBuyNowPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2cdb8",
  null
  
)

export default component.exports